/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     个人中心 API 接口
  +--------------------------------------------------------------------------------------
*/
import request from "@/utils/request";

export function getMeApi(query) {
  return request({
    url: "?c=me&a=me&do=get",
    method: "get"
  });
}

export function editorMeApi(data) {
  return request({
    url: "?c=me&a=me&do=edit",
    method: "post",
    data
  });
}
